import { facadeApi } from 'api'

interface Params {
  rejectReason: string
  requestId: string
}

export const rejectHierarchyAccessRequestApi = ({ rejectReason, requestId }: Params) =>
  facadeApi.patch(`/hierarchy-requests/${requestId}/reject`, { rejectReason })
